
import LogTypeList from './list.vue'
import LogTypeEdit from "./edit.vue";

let a = Object.assign({LogTypeList,LogTypeEdit});
export default a;